import React from "react";

const FieldOptionContext = React.createContext({
  fieldOption: null,
  setFieldOption: () => {},
});

export default FieldOptionContext;
